import { getWhatsappLinkFromPhone } from "./getWhatsappLinkFromPhone";

/** Separa nome do número (ex.: "66999941994 - WILLIAM"). Evita quebrar telefones com hífen interno. */
const NAME_SEP = " - ";

function parseWhatsappSegment(segment) {
  const trimmed = String(segment).trim();
  if (!trimmed) return null;

  let phone;
  let name = null;
  const nameIdx = trimmed.indexOf(NAME_SEP);
  if (nameIdx === -1) {
    phone = trimmed;
  } else {
    phone = trimmed.slice(0, nameIdx).trim();
    name = trimmed.slice(nameIdx + NAME_SEP.length).trim() || null;
  }
  if (!phone) return null;

  const whatsappLink = getWhatsappLinkFromPhone(phone);
  const label = name ? `${phone} — ${name}` : phone;

  return { phone, name, label, whatsappLink };
}

/**
 * Aceita um único número ou vários no formato:
 * "66999941994 - WILLIAM/66999883626 - ELIÉSER/66999941929 - PAMELA"
 */
export function parseWhatsappContactsString(whatsapp) {
  if (whatsapp == null) return [];
  const raw = String(whatsapp).trim();
  if (!raw) return [];

  return raw.split("/").map(parseWhatsappSegment).filter(Boolean);
}

export function getStoreWhatsappContacts(store) {
  return parseWhatsappContactsString(store.whatsapp);
}
